export enum WexCardTransactionType {
  Authorization = 0,
  Transaction = 1
}

export type WexCardTransaction = {
  Amount: number;
  ApprovalCode: string;
  BillingCurrency: string | null;
  MccCode: string | null;
  MerchantAddress: string | null;
  MerchantName: string | null;
  PostingDate: Date | null;
  RemainingCredit: number | null;
  ResponseCode: string;
  ResponseCodeDescription: string | null;
  TransactionDate: Date;
  Type: WexCardTransactionType;
  WasApproved: boolean;
};
